const getStyles = () => {
  return {
    section: {
      position: 'relative',
      padding: { xs: '60px 20px', md: '120px 20px' },
      overflow: 'hidden'
      // background:
      //   'linear-gradient(180deg, #0a0e27 0%, #1a1f3a 50%, #0a0e27 100%)'
    },

    // Background Elements
    backgroundContainer: {
      position: 'absolute',
      inset: 0,
      overflow: 'hidden',
      pointerEvents: 'none'
    },

    gradientBase: {
      position: 'absolute',
      inset: 0,
      background:
        'radial-gradient(circle at 50% 50%, rgba(12, 90, 219, 0.1) 0%, transparent 70%)'
    },

    geometricPattern1: {
      position: 'absolute',
      top: '10%',
      right: '5%',
      width: '300px',
      height: '300px',
      border: '2px solid rgba(58, 142, 246, 0.2)',
      borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%',
      transition: 'transform 0.3s ease-out'
    },

    geometricPattern2: {
      position: 'absolute',
      bottom: '15%',
      left: '8%',
      width: '250px',
      height: '250px',
      border: '2px solid rgba(138, 43, 226, 0.2)',
      borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%',
      transition: 'transform 0.3s ease-out'
    },

    floatingOrb1: {
      position: 'absolute',
      top: '5%',
      left: '15%',
      width: '400px',
      height: '400px',
      borderRadius: '50%',
      background:
        'radial-gradient(circle, rgba(12, 90, 219, 0.3) 0%, transparent 70%)',
      filter: 'blur(60px)',
      animation: 'pulse 6s ease-in-out infinite'
    },

    floatingOrb2: {
      position: 'absolute',
      bottom: '10%',
      right: '10%',
      width: '500px',
      height: '500px',
      borderRadius: '50%',
      background:
        'radial-gradient(circle, rgba(138, 43, 226, 0.25) 0%, transparent 70%)',
      filter: 'blur(80px)',
      animation: 'pulse 8s ease-in-out infinite'
    },

    gridPattern: {
      position: 'absolute',
      inset: 0,
      backgroundImage: `
        linear-gradient(rgba(58, 142, 246, 0.03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(58, 142, 246, 0.03) 1px, transparent 1px)
      `,
      backgroundSize: '50px 50px',
      opacity: 0.5
    },

    spotlight1: {
      position: 'absolute',
      top: '20%',
      right: '10%',
      width: '400px',
      height: '400px',
      background:
        'radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, transparent 70%)',
      borderRadius: '50%',
      filter: 'blur(50px)',
      transition: 'transform 0.6s ease-out'
    },

    spotlight2: {
      position: 'absolute',
      bottom: '30%',
      left: '5%',
      width: '350px',
      height: '350px',
      background:
        'radial-gradient(circle, rgba(58, 142, 246, 0.1) 0%, transparent 70%)',
      borderRadius: '50%',
      filter: 'blur(60px)',
      transition: 'transform 0.6s ease-out'
    },

    // Content Styles
    container: {
      position: 'relative',
      maxWidth: '1400px',
      margin: '0 auto',
      zIndex: 10
    },

    header: {
      textAlign: 'center',
      marginBottom: { xs: '40px', md: '80px' },
      animation: 'fadeInUp 0.8s ease-out'
    },

    headerBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 20px',
      marginBottom: '30px',
      borderRadius: '50px',
      background: 'rgba(255, 255, 255, 0.05)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(58, 142, 246, 0.3)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
    },

    badgeIcon: {
      fontSize: '16px'
    },

    badgeText: {
      fontSize: '13px',
      fontWeight: 600,
      color: '#0a0e27',
      letterSpacing: '0.5px',
      textTransform: 'uppercase'
    },

    title: {
      fontSize: { xs: '26px', sm: '38px', md: '56px' },
      fontWeight: 900,
      marginBottom: '24px',
      color: '#0a0e27',
      lineHeight: 1.2
    },

    titleGradient: {
      background:
        'linear-gradient(135deg, #0c5adb 0%, #3a8ef6 50%, #8a2be2 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      backgroundSize: '200% 200%',
      animation: 'gradientShift 3s ease infinite'
    },

    subtitle: {
      fontSize: { xs: '14px', sm: '16px', md: '18px' },
      color: '#414243ff',
      maxWidth: '700px',
      margin: '0 auto',
      lineHeight: 1.8,
      fontWeight: 300
    },

    // Grid Styles
    grid: {
      display: 'grid',
      gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(auto-fit, minmax(300px, 1fr))'
      },
      gap: { xs: '24px', md: '32px' },
      marginBottom: { xs: '40px', md: '80px' }
    },

    gridItem: {
      animation: 'fadeInUp 0.6s ease-out backwards'
    },

    clientCard: {
      position: 'relative',
      height: '100%',
      background: 'rgba(119, 119, 119, 0.18)',
      backdropFilter: 'blur(20px)',
      borderRadius: '24px',
      overflow: 'hidden',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
        transition: 'all 0.4s ease'
      }
    },

    cardGlow: {
      position: 'absolute',
      inset: '-50%',
      filter: 'blur(40px)',
      transition: 'all 0.4s ease',
      pointerEvents: 'none'
    },

    animatedBorder: {
      position: 'absolute',
      inset: 0,
      borderRadius: '24px',
      border: '1px solid',
      transition: 'all 0.4s ease',
      pointerEvents: 'none'
    },

    cardContent: {
      position: 'relative',
      padding: { xs: '30px 24px', md: '40px 32px' },
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
      zIndex: 2
    },

    iconContainer: {
      position: 'relative',
      width: { xs: '80px', md: '100px' },
      height: { xs: '80px', md: '100px' },
      borderRadius: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
      // boxShadow:
      //   '0 10px 40px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
      // transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
    },

    iconInner: {
      position: 'relative',
      zIndex: 2
    },

    icon: {
      width: '100%',
      height: '62px',
      fontSize: { xs: '36px', md: '48px' }
      // filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))'
    },

    iconRing: {
      position: 'absolute',
      inset: '-10px',
      borderRadius: '24px',
      border: '2px solid',
      pointerEvents: 'none'
    },

    clientInfo: {
      textAlign: 'center'
    },

    clientName: {
      fontSize: '18px',
      fontWeight: 700,
      color: '#0a0e27',
      marginBottom: '8px',
      letterSpacing: '-0.5px',
      '@media (max-width: 768px)': {
        fontSize: '18px'
      },
      '@media (max-width: 425px)': {
        fontSize: '16px'
      }
    },

    clientCategory: {
      fontSize: '14px',
      color: '#0a0e27',
      fontWeight: 500,
      textTransform: 'uppercase',
      letterSpacing: '1px'
    },

    cornerTopLeft: {
      position: 'absolute',
      top: '16px',
      left: '16px',
      width: '20px',
      height: '20px',
      borderTop: '2px solid rgba(255, 255, 255, 0.1)',
      borderLeft: '2px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '4px 0 0 0'
    },

    cornerBottomRight: {
      position: 'absolute',
      bottom: '16px',
      right: '16px',
      width: '20px',
      height: '20px',
      borderBottom: '2px solid rgba(255, 255, 255, 0.1)',
      borderRight: '2px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '0 0 4px 0'
    },

    shimmer: {
      position: 'absolute',
      inset: 0,
      background:
        'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)',
      animation: 'shimmerSlide 2s ease-in-out infinite',
      transition: 'opacity 0.3s ease'
    },

    // Bottom Decoration
    bottomDecoration: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '20px',
      marginTop: { xs: '40px', md: '60px' }
    },

    decorationLine: {
      width: { xs: '80px', md: '150px' },
      height: '1px',
      background:
        'linear-gradient(90deg, transparent, rgba(58, 142, 246, 0.5), transparent)'
    },

    decorationCircle: {
      width: { xs: '50px', md: '60px' },
      height: { xs: '50px', md: '60px' },
      borderRadius: '50%',
      background: 'rgba(255, 255, 255, 0.03)',
      border: '1px solid rgba(58, 142, 246, 0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      animation: 'float 3s ease-in-out infinite'
    },

    decorationIcon: {
      fontSize: { xs: '20px', md: '24px' }
    },

    // Animation Keyframes
    '@keyframes fadeInUp': {
      from: {
        opacity: 0,
        transform: 'translateY(40px)'
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)'
      }
    },

    '@keyframes float': {
      '0%, 100%': {
        transform: 'translateY(0px)'
      },
      '50%': {
        transform: 'translateY(-20px)'
      }
    },

    '@keyframes pulse': {
      '0%, 100%': {
        opacity: 0.4
      },
      '50%': {
        opacity: 0.8
      }
    },

    '@keyframes rotate360': {
      from: {
        transform: 'rotate(0deg)'
      },
      to: {
        transform: 'rotate(360deg)'
      }
    },

    '@keyframes ping': {
      '0%': {
        transform: 'scale(1)',
        opacity: 1
      },
      '75%, 100%': {
        transform: 'scale(1.5)',
        opacity: 0
      }
    },

    '@keyframes shimmerSlide': {
      '0%': {
        transform: 'translateX(-100%) translateY(-100%) rotate(45deg)'
      },
      '100%': {
        transform: 'translateX(100%) translateY(100%) rotate(45deg)'
      }
    },

    '@keyframes gradientShift': {
      '0%, 100%': {
        backgroundPosition: '0% 50%'
      },
      '50%': {
        backgroundPosition: '100% 50%'
      }
    }
  };
};

export default getStyles;
